import {AbstractControl} from '@angular/forms';
import {of, debounceTime, map, take} from 'rxjs';
import {ActivationService} from '@ee/common/services';

export class SubdomainNotTakenValidator {

  static SUBDOMAIN_KEY_PATTERN = '^[a-zA-Z0-9-]*$';

  static createValidator(activateAttorneyService: ActivationService, errorWhenMissing = false) {
    return (control: AbstractControl) => {
      control.markAllAsTouched();
      if (!control.value) {
        return of(null);
      }
      return activateAttorneyService.validateSubdomain(control.value).pipe(
        debounceTime(1000),
        take(1),
        map(res => {
          let result = {subdomain: true};
          if ((errorWhenMissing && !res) || (!errorWhenMissing && res)) {
            result = null; // don't show error
          }
          return result;
        }));
    };
  }
}
